import * as React from 'react';
import NavHelper from '../components/NavHelper';

class Sponsorship extends React.PureComponent {
  render(): JSX.Element {
    return (
      <div>
        <NavHelper pageName="Sponsorship" icon="fa-child" />
        <section id="main-content" className="main-content pad-60">
          <div className="container">
            <div className="row">
              <div className="col-sm-4 col-xs-12">
                <img src="assets/images/sponsorships/girl-cooking.jpg" className="img-responsive" alt="volunteer-2" />
              </div>
              <div className="col-sm-8 col-xs-12">
                <div className="article pad-b-60">
                  <h2>Sponsor a Girl</h2>
                  <p>Sponsoring a girl's education is one of the most important things you can do to help her achieve a better life. Here's what you need to know.</p>
                  <p>$35 per month can give a girl professional education. With your sponsorship, you will receive:
                  </p>
                  <ul className="fa-ul">
                    <li><i className="fa-li fa fa-female" /> A photo of your sponsored girl</li>
                    <li><i className="fa-li fa fa-pencil" /> A short, introductory letter from your sponsored girl</li>
                    <li><i className="fa-li fa fa-gears" /> Regular progress reports from the girl's professional course and from Pro-Ema social work department.</li>
                    <li><i className="fa-li fa fa-plane" /> The chance to make a lifelong connection. Many sponsors and girls can stay in touch for years, even after graduation</li>
                  </ul>
                </div> {/*/.article*/}
              </div>
            </div> {/*/.row*/}
            <div className="row">
              <div className="col-sm-8 col-xs-12">
                <div className="article">
                  <h2>Yes, I would like to sponsor a girl!</h2>
                  <p>Thank you for your generous decision! You can first select a girl to sponsor by emailing <a href="mailto:proema.timorleste@gmail.com">proema.timorleste@gmail.com</a>.
                    We will reply and guide you through the process.
                  </p>
                </div> {/*/.article*/}
              </div>
              <div className="col-sm-4 col-xs-12">
                <img src="assets/images/sponsorships/girl-graduation.jpg" className="img-responsive" alt="volunteer-2" />
              </div>
            </div> {/*/.row*/}
          </div> {/*/.container*/}
        </section>
      </div>);
  }
}

export default Sponsorship;



// WEBPACK FOOTER //
// ./src/page/Sponsorship.tsx